import React from 'react';
import { Link } from 'react-router-dom';
import { Check, ClipboardList, Files, Palette, Repeat2, Users, Workflow } from 'lucide-react';
import { useI18n } from '../../i18n/I18nContext';
import './Business.css';

const WORKFLOW_ICONS = [Palette, ClipboardList, Users, Files, Repeat2, Workflow];

const Business: React.FC = () => {
  const { content } = useI18n();
  const business = content.business;

  return (
    <section className="business section" aria-label={business.aria}>
      <div className="container business__layout">
        <div className="business__main">
          <h2>{business.title}</h2>
          <p>{business.intro}</p>
          <ul className="business__features">
            {business.workflow.map((label, index) => {
              const Icon = WORKFLOW_ICONS[index];
              return <li key={label}><Icon size={17} strokeWidth={1.7} /><span>{label}</span></li>;
            })}
          </ul>
          <div className="business__actions">
            <Link to="/contact" className="btn btn-primary">{business.primary}</Link>
            <Link to="/request" className="btn btn-outline">{business.secondary}</Link>
          </div>
        </div>
        <div className="business__cases">
          <span className="business__cases-label">{business.casesLabel}</span>
          {business.cases.map(useCase => (
            <article key={useCase.title} className="business__case">
              <span><Check size={16} /></span>
              <div><h3>{useCase.title}</h3><p>{useCase.description}</p></div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Business;
